import Phaser from 'phaser';
import { gameConfig } from './config/gameConfig';
import { BootScene } from './scenes/BootScene';
import { MenuScene } from './scenes/MenuScene';
import { ColdOpenScene } from './scenes/ColdOpenScene';
import { ARFloorScene } from './scenes/ARFloorScene';
import { DesktopScene } from './scenes/DesktopScene';
import { EndingScene } from './scenes/EndingScene';
import { PauseScene } from './scenes/PauseScene';

// Phaser's Text rasterizes at resolution=1 by default. On HiDPI/Retina
// displays the FIT-scaled canvas then upsamples those glyphs, producing
// blurry text. Wrap the factory once so every this.add.text(...) renders
// at the device's pixel density.
const dpr = Math.max(1, window.devicePixelRatio || 1);
const factoryProto = Phaser.GameObjects.GameObjectFactory.prototype as unknown as {
  text: (...args: unknown[]) => Phaser.GameObjects.Text;
};
const originalText = factoryProto.text;
factoryProto.text = function (this: Phaser.GameObjects.GameObjectFactory, ...args: unknown[]) {
  const txt = originalText.apply(this, args);
  txt.setResolution(dpr);
  return txt;
};

class ARRushGame extends Phaser.Game {
  constructor() {
    const config: Phaser.Types.Core.GameConfig = {
      ...gameConfig,
      scene: [BootScene, MenuScene, ARFloorScene, ColdOpenScene, DesktopScene, EndingScene, PauseScene],
    };
    super(config);
    const loadingEl = document.getElementById('loading');
    if (loadingEl) loadingEl.style.display = 'none';
  }
}

window.addEventListener('load', () => {
  const game = new ARRushGame();
  (window as unknown as { __arrush: Phaser.Game }).__arrush = game;
});
